export const move = (arr, oldIndex, newIndex) => {
  let newArr = [...arr];
  if (newIndex >= newArr.length) {
    newArr.length = newIndex + 1;
  }
  newArr.splice(newIndex, 0, newArr.splice(oldIndex, 1)[0]);
  return newArr;
};

// See https://react-dnd.github.io/react-dnd/examples/sortable/simple for reference

export const onHover = (item, monitor, index, ref, onMove) => {
  if (!ref.current) {
    return;
  }
  const dragIndex = item.index;
  const hoverIndex = index;
  // Don't replace items with themselves
  if (dragIndex === hoverIndex) {
    return;
  }
  // Determine rectangle on screen
  const hoverBoundingRect = ref.current.getBoundingClientRect();
  // Get vertical middle
  const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
  // Determine mouse position
  const clientOffset = monitor.getClientOffset();
  // Get pixels to the top
  const hoverClientY = clientOffset.y - hoverBoundingRect.top;
  // Dragging downwards
  if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
    return;
  }
  // Dragging upwards
  if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
    return;
  }
  // A good place to update the UI
  onMove(dragIndex, hoverIndex);
  item.index = hoverIndex;
};
